// React
import { useBlocker } from "react-router-dom";
import { ConfirmModal } from "../ConfirmModal";

/**
 * @description Brings up a confirmation modal when the user tries to navigate away
 *
 * @param {onlyBlockWhen} (optional) Only block when this expression is true, in addition to when the user navigates away (e.g. dirty form)
 */

const ConfirmLeaveModal = ({ onlyBlockWhen = true }) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      onlyBlockWhen && currentLocation.pathname !== nextLocation.pathname
  );

  return (
    <ConfirmModal
      open={onlyBlockWhen && blocker.state === "blocked"}
      onConfirm={() => blocker.proceed()}
      onClose={() => blocker.reset()}
      translationKey="navigation"
    />
  );
};

export default ConfirmLeaveModal;
